import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { toast } from "react-toastify";

const StatusInfo = ({ asset }) => {
  const [assetName, setAssetName] = useState("");
  const [isMedical, setIsMedical] = useState("0");
  const [assetNote, setAssetNote] = useState("");
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    if (asset) {
      setAssetName(asset.name || "");
      setIsMedical(asset.is_medical?.toString() || "0");
      setAssetNote(asset.asset_note || "");
    }
  }, [asset]);

  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleSave = async (e) => {
    e.preventDefault(); // REQUIRED for forms

    try {
      const formData = new FormData();

      formData.append("asset_id", asset.assets_id);
      formData.append("asset_name", assetName);
      formData.append("is_medical", isMedical);
      formData.append("asset_note", assetNote);

      if (imageFile) {
        formData.append("asset_image", imageFile);
      }

      // LOG values
      formData.append("old_assetName", asset.name);
      formData.append("old_mdstatus", asset.is_medical);
      formData.append("old_assetNote", asset.asset_note);
      formData.append("new_mdstatus", isMedical);

      await axios.post(`${API_BASE_URL}/asset/status-info`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      toast.success("Other information updated!", {
        position: "bottom-right",
      });

    } catch (err) {
      toast.error("Update failed!", { position: "bottom-right" });
      console.error("Status update error:", err);
    }
  };

  return (
    <div className="card p-3">
      <h5 className="mb-3">Other Information</h5>

      {/* FIXED FORM WRAPPING */}
      <form onSubmit={handleSave}>
        <div className="row">

          {/* Asset Name */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Asset Name</label>
            <input
              className="form-control"
              value={assetName}
              onChange={(e) => setAssetName(e.target.value)}
              placeholder="Enter Asset Name"
            />
          </div>

          {/* Medical Equipment */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Medical Equipment?</label>
            <select
              className="form-control"
              value={isMedical}
              onChange={(e) => setIsMedical(e.target.value)}
            >
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>

          {/* Image Upload */}
          <div className="col-md-4 mb-3">
            <label className="form-label">Asset Image</label>
            <input
              type="file"
              className="form-control"
              onChange={handleImageChange}
            />
          </div>

          {/* Asset Note */}
          <div className="col-md-12 mb-3">
            <label className="form-label">Note</label>
            <textarea
              className="form-control"
              rows={3}
              value={assetNote}
              onChange={(e) => setAssetNote(e.target.value)}
              placeholder="Enter asset note"
            ></textarea>
          </div>

        </div>

        {/* Save Button INSIDE form */}
        <button className="btn btn-primary btn-sm mt-3" type="submit">
          Save
        </button>

      </form>
    </div>
  );
};

export default StatusInfo;
